import { useState } from 'react'
import { styled } from '@mui/material/styles'
import MuiDrawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { Collapse, FormControlLabel, ListItemButton, Slider } from '@mui/material'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { useDispatch, useSelector } from 'react-redux'
import { getUnits, setFilters, setPage } from '../../actions/viewerActions'
import TextField from '@mui/material/TextField'
import Switch from '@mui/material/Switch'
import Tune from '@mui/icons-material/Tune'
import Icon from '@mui/material/Icon'
import Button from '@mui/material/Button'
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'
import Search from '@mui/icons-material/Search'

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'hidden'
})

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`
  }
})

const drawerWidth = 240

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar
}))

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme)
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme)
    })
  })
)

// eslint-disable-next-line react/prop-types
const FilterItem = ({ filter, children, collapse, toggleCollapse, icon }) => {
  return (
        <>
            <ListItemButton onClick={() => { toggleCollapse(filter) }}>
                <ListItemIcon>
                    <Icon>{icon}</Icon>
                </ListItemIcon>
                <ListItemText primary={filter} />
                {collapse[filter] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={collapse[filter]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem>
                        {children}
                    </ListItem>

                </List>
            </Collapse>

        </>
  )
}

const Filters = () => {
  const [open, setOpen] = useState(false)
  const max = useSelector(state => state.viewer.max)
  const [noiseLevel, setNoiseLevel] = useState(0)
  const [showOnlyAvailables, setShowOnlyAvailables] = useState(true)
  const [collapse, setCollapse] = useState({
    available: false,
    price: false,
    noiseLevel: false
  })

  const toggleCollapse = (key) => {
    const collapseValues = { ...collapse }
    collapseValues[key] = !collapse[key]
    setCollapse(collapseValues)
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setCollapse({
      available: false,
      price: false,
      noiseLevel: false
    })
    setOpen(!open)
  }

  const dispatch = useDispatch()
  const [formValues, setFormValues] = useState({
    show_only_availables: true
  })

  const handleChange = (event, newValue) => {
    const name = event.target.name
    const value = name === 'show_only_availables'
      ? event.target.checked
      : event.target.value || newValue

    if (name === 'noise_level') {
      setNoiseLevel(value)
    }

    setFormValues((allValues) => {
      return (
        {
          ...allValues,
          [name]: value
        }
      )
    })
  }

  const handleSubmit = (event) => {
    Object.filter = (obj, predicate) =>
      Object.keys(obj)
        .filter(key => predicate(obj[key]))
        .reduce((res, key) => {
          res[key] = obj[key]
          return res
        }, {})
    const filtered = Object.filter(formValues, value => value !== '')
    filtered.max = max
    filtered.page = 1
    event && event.preventDefault()
    dispatch(setFilters(filtered))
    dispatch(setPage(1))
    dispatch(getUnits(filtered))
  }

  const handleClear = () => {
    setNoiseLevel(0)
    setShowOnlyAvailables(false)
    setFormValues({})
    dispatch(setFilters({}))
    dispatch(getUnits({ max: 9 }))
  }

  return (
        <Drawer variant="permanent" open={open}>
            <DrawerHeader >
                <IconButton onClick={handleDrawerClose}>
                    <Tune />
                </IconButton>
            </DrawerHeader>
            <Divider />
            <List>
                <FilterItem icon="task_alt" collapse={collapse} toggleCollapse={toggleCollapse} filter={'Availables'}>
                    <FormControlLabel
                        label="Show only available"
                        control={
                            <Switch
                                name="show_only_availables"
                                value={showOnlyAvailables}
                                onChange={handleChange}/>
                        }
                    />
                </FilterItem>
                <Divider />
                <FilterItem icon="paid" collapse={collapse} toggleCollapse={toggleCollapse} filter={'Price'}>
                    <TextField
                        onChange={handleChange}
                        value={formValues.price_min}
                        label="Min"
                        name="price_min"
                        size="small"
                        type="number"
                        variant="standard"
                    />
                    &nbsp;&nbsp;&nbsp;
                    <TextField
                        onChange={handleChange}
                        value={formValues.price_max}
                        label="Max"
                        name="price_max"
                        size="small"
                        type="number"
                        variant="standard"
                    />
                </FilterItem>
                <Divider />
                <FilterItem icon="graphic_eq" collapse={collapse} toggleCollapse={toggleCollapse} filter={'noiseLevel'}>
                    <Slider
                        size="small"
                        value={noiseLevel}
                        aria-label="Small"
                        valueLabelDisplay="auto"
                        onChange={handleChange}
                        name="noise_level"
                    />
                </FilterItem>
                <Divider />
                {open &&
                    <ListItem>
                        <Button style={{ backgroundColor: 'gray' }} variant="contained" onClick={handleClear} startIcon={<CleaningServicesIcon />}>Clear</Button>
                        &nbsp;
                        &nbsp;
                        <Button color="primary" variant="contained" onClick={handleSubmit} endIcon={<Search />}>Search</Button>
                    </ListItem>
                }

            </List>
        </Drawer>
  )
}

export default Filters
